import { ChevronRightIcon } from '@/app/common/icons/arrows'
import { CameraSVG } from '@/app/common/icons/general'
import useStudenDetailsDocumentParams, {
  specialEducationForms,
  SpecialEducationForms,
} from './hooks/useStudentDetailsDocumentParams'
import { useTranslation } from 'react-i18next'
import { useTypesafeStudent } from './useTypesafeStudent'

export const SpecialEducationDocumentType = () => {
  const { t: translate } = useTranslation()
  const { onStudentDetailFormSelect } = useStudenDetailsDocumentParams()
  const { fullName } = useTypesafeStudent()

  const selectform = (code: SpecialEducationForms) => {
    onStudentDetailFormSelect(code)
  }

  return (
    <>
      <div className="text-3xl text-center font-medium text-gray-900 mb-10 sm:mb-5">
        {translate('select_document_type')}
      </div>
      <div className="flex items-center justify-center">
        <CameraSVG className="h-10 w-10 mb-4" />
      </div>

      <div className="text-xl font-medium text-gray-900 mb-5 sm:mb-5 text-center">
        {translate('we_need_a_picture_of_your_special_education_form').replace(
          ':student_name',
          fullName
        )}
      </div>

      <div className="text-sm text-center text-gray-800">
        {translate(
          'please_select_one_of_the_following_special_education_forms'
        )}
      </div>

      <ul role="list" className="-mx-2 space-y-2 mt-12 h-full">
        {specialEducationForms.map((item) => (
          <li key={item.name}>
            <a
              className={'flex p-2 font-semibold'}
              onClick={() => {
                selectform(item.code as SpecialEducationForms)
              }}
            >
              <div className="flex h-full w-full">
                <div className="flex flex-col">
                  <div className="flex">
                    <div className="ml-2 text-sm">{translate(item.name)}</div>
                  </div>
                  <div className="ml-2 text-gray-500 text-xs font-light">
                    {translate(item.description)}
                  </div>
                </div>
                <div className="flex flex-grow items-center justify-end">
                  <ChevronRightIcon />
                </div>
              </div>
            </a>
            <hr />
          </li>
        ))}
      </ul>
    </>
  )
}
